import { imageVariantLink } from '@/common/file-variants';

import type { Vessel, VesselDto, VesselsPage, VesselsPageDto } from './vessels.types';

/** The largest box a vessel image is drawn in (vessel detail header). */
const VESSEL_IMAGE_BOX = 56;

export const mapVessel = (dto: VesselDto): Vessel => ({
  id: dto.id,
  name: dto.vessel_name,
  image: imageVariantLink(dto.image, VESSEL_IMAGE_BOX) || null,
  ownerId: dto.owner_id ?? null,
});

export const mapVesselsPage = (dto: VesselsPageDto): VesselsPage => ({
  count: dto.count,
  items: (dto.items ?? []).map(mapVessel),
});
